import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  main: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: -8,
    marginBottom: -8,
    justifyContent: 'center',
  },
  chip: { margin: 4 },
});

export const NbBranchesField = props => {
  const classes = useStyles();
  const { record } = props;

  if (!record) {
    return null;
  };

  return (
    <span className={classes.main}>
      {record.provider_location &&
        <Chip className={classes.chip} label={record.provider_location.length} />
      }
    </span>
  );
};

NbBranchesField.defaultProps = {
  label: 'Branch(es)',
  textAlign: 'center',
};
